<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>员工中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">成本日报</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!addHideIs && !editHideIs" style="position: relative;">
      <section class="searchBox">
        <span>
          <label>日期：</label>
          <!-- <a-date-picker style="width:120px" /> -->
          <a-range-picker style="width:200px" @change="onSelectData" />
        </span>
        <span>
          <label>项目：</label>
          <a-select
            style="min-width:150px"
            v-model="project_id"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in proList"
              :key="element.id"
              :value="element.id"
              >{{ element.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>渠道：</label>
          <a-select
            style="min-width:110px"
            v-model="resume_source_id"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              :value="element.id"
              v-for="(element, k) in channelList"
              :key="k"
              >{{ element.source_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>姓名：</label>
          <a-input
            style="width:100px"
            placeholder="请输入姓名"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button @click="onReset" class="resetStyle">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.day.substring(0, 10) }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.source_name }}</td>
              <td>{{ item.project_name }}</td>
              <td>{{ item.num }}</td>
              <td>{{ Number(item.price) + "元" }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 新增 -->
    <addCostDaily v-show="addHideIs" v-on:hideInAdd="hideInAdd" />
    <!-- 新增 end -->
    <!-- 编辑 -->
    <costDailyEdit
      v-show="editHideIs"
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 编辑 end -->
  </div>
</template>

<script>
import axios from "axios";
import addCostDaily from "@/components/resume/addCostDaily.vue"; //增加
import costDailyEdit from "@/components/resume/costDailyEdit.vue"; //编辑
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: ["日期", "操作人", "渠道", "项目", "上贴数量", "花费成本"],
      isHideDetails: false,
      detailsStr: {},
      query_field: "",
      addHideIs: false,
      editHideIs: false,
      editDetail: {},
      searchDate: "",
      project_id: "",
      position_id: [],
      proList: [],
      channelList: [],
      resume_source_id: "",
      day: "",
      start_date: "",
      end_date: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addCostDaily,
    costDailyEdit
  },
  mounted() {
    this.getData(); //获取列表
    this.getChannel(); //获取渠道
    this.getPro(); //获取项目
  },
  methods: {
    onSelectData(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
    },
    getChannel() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_source/resumeSourceList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 10000
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.channelList = res.data.data.data;
        }
      });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    detailPage(val) {
      // console.log(val)
      this.detailsStr = val;
      this.isHideDetails = true;
    },
    hideInEdit(isShow) {
      this.editHideIs = isShow;
      this.reload();
    },
    onReset() {
      this.resume_source_id = "";
      this.project_id = "";
      this.start_date = "";
      this.end_date = "";
      this.page = 1;
      this.getData();
    },
    hideInAdd(isHide) {
      this.addHideIs = isHide;
      this.reload();
    },
    backHref() {
      this.addHideIs = false;
      this.editHideIs = false;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url + this.httpsBasic.recruitment + "Day/dayList";
      let params = {
        current_page: this.page,
        per_page: 10,
        project_id: this.project_id,
        resume_source_id: this.resume_source_id,
        start_date: this.start_date,
        end_date: this.end_date,
        query_field: this.query_field,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      if (this.start_date == "") {
        delete params.start_date;
        delete params.end_date;
      }
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    editPage(val) {
      this.editHideIs = true;
      this.editDetail = val;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);

.listContainer {
  .searchBox {
    padding: 14px 2%;
    display: block;
    .resetStyle {
      margin-right: 10px;
    }
    span {
      display: inline-block;
      //
      margin-right: 20px;
      margin-bottom: 10px;
    }
    > div {
      margin-bottom: 10px;
      display: inline-block;
    }
    .searchTxt {
      justify-content: flex-end;
    }
    input {
      margin: 0 10px;
      width: 160px;
    }
    .addStyle {
      margin: 0 60px 14px 0;
    }
  }
}
.assignedBox {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  h3 {
    font-size: 14px;
    text-align: center;
    margin: 10px 0 20px;
  }
  > div {
    background: #fff;
    margin: 12% 30%;
    padding: 20px 4% 40px;
    border-radius: 10px;
    ul {
      li {
        margin-bottom: 10px;
        i {
          font-style: normal;
          color: red;
          display: inline-block;
          margin-right: 4px;
        }
      }
    }
    > div {
      margin-top: 30px;
      button {
        margin-right: 12px;
      }
    }
  }
}
.taskImg {
  height: 20px;
}
</style>
